import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Card,
  Table,
  Button,
  Checkbox,
  Tag,
  Select,
  Space,
  Spin
} from "antd";
import { PageHeader } from '@ant-design/pro-components';

import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { ExpandAltOutlined, EditOutlined } from "@ant-design/icons";
import { AlignType } from 'rc-table/lib/interface';

import { apiCand } from "../../../services/apiCand";

import { maskCpf } from "../../../utils/maskFunctions";

import { useNavigate } from "react-router-dom";
import { errorMessage, infoMessage } from "../../../utils/messages";

import { IDirigenteExcepcional, IDirigenteExcepcionalConsulta } from "../Componentes/InterfaceDirigenteExcepcional";

import "../style.css";
import { onlyNumbers } from "../../../utils/utilsFunctions";
import { IEntidade } from "../../../Interfaces/DadosPrevicInterfaces";
import { getEntidadesDoUsuarioConsultar } from "../../../auth/entidadeUsuario";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../parametrosUI";
import { limparPesquisaSalva, obterPesquisa, salvarPesquisa } from "../../../utils/contextoPesquisa";
import { obterFuncoesDirigenteExcepcional } from "../Componentes/EnumsParaDirigenteExcepcional";

const { Option } = Select;

const Consultar: React.FC<any> = (props: any) => {
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const [dirigenteExcepcional, setDirigenteExceptional] = useState<IDirigenteExcepcional>();
  const [diritentesExcepcionais, setDiritentesExcepcionais] = useState<IDirigenteExcepcionalConsulta[]>([]);

  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);

  const [manter, setManter] = useState(2); // ESTADOS PARA PASSAR PARA A TELA SEGUINTE - 2 : Detalhar / 3 : Alterar;

  const funcoes = obterFuncoesDirigenteExcepcional();

  useEffect(() => {
    window.scrollTo(0, 0);

    const pesquisaSalva = obterPesquisa('dirigenteExcepcional');
    if (pesquisaSalva){

      setDiritentesExcepcionais(pesquisaSalva.resultado);
      setTotalElements(pesquisaSalva.resultado.length);

      form.setFieldsValue({
        matriculaEfpc: pesquisaSalva.parametros.matriculaEfpc,
        nuCpf: maskCpf(pesquisaSalva.parametros.nuCpf),
        nmPessoaFisica: pesquisaSalva.parametros.nmPessoaFisica,
        idFuncao: pesquisaSalva.parametros.idFuncao,
        checkConsultaAtivo: pesquisaSalva.parametros.consultaAtivo,
        checkConsultaInativo: pesquisaSalva.parametros.consultaInativo,

        entidade: pesquisaSalva.nmTextos.entidade,
        nmFuncao: pesquisaSalva.nmTextos.nmFuncao,
      });
    }

    const entidadeUsuario = getEntidadesDoUsuarioConsultar();
    setEntidades(entidadeUsuario);
    if (entidadeUsuario.length === 1){
      form.setFieldsValue({
        entidade: entidadeUsuario[0].sigla,
        matriculaEfpc: entidadeUsuario[0].matricula,
      });
    }
    
  }, []);

  useEffect(() => {
    if (dirigenteExcepcional) pushToManter(dirigenteExcepcional, manter);
  }, [dirigenteExcepcional]);

  function pushToManter(oc: any, manter: number) {
    let tpSelecao = {
      manter: manter,
      data: oc
    };

    navigate("/dirigente-excepcional/manter", { state: tpSelecao });
  }

  function gerarColunas() {
    let cols: any[] = [];

    cols.push({
      key: "SIGLA",
      width: 150,
      title: "Entidade",
      dataIndex: "sigla",
    });

    cols.push({
      key: "cpf",
      width: 150,
      title: "CPF",
      dataIndex: "",
      render: (oc: IDirigenteExcepcionalConsulta) => (
        <Input
          value={maskCpf(oc.nuCpf)}
          size={"small"}
          style={{ padding: 0 }}
          variant="borderless"
        />
      ),
    });

    cols.push({
      key: "nome",
      // width: 400,
      title: "Nome Completo",
      dataIndex: "nmPessoaFisica",
    });

    cols.push({
      key: "dtFimAtuacao",
      width: 100,
      title: "Data de término",
      dataIndex: "dtFimAtuacao",
    });

    cols.push({
      key: "situacao",
      width: 80,
      title: "Situação",
      dataIndex: "",
      render: (oc: IDirigenteExcepcionalConsulta) => (
        <>
          <Tag color={oc.situacaoVigencia ? "geekblue" : "volcano"} key={oc.idDirExcepcional}>
            {oc.situacaoVigencia && oc.situacaoVigencia ? "ATIVO" : "INATIVO"}
          </Tag>
        </>
      ),
    });

    cols.push({
      key: "opcoes",
      width: 80,
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (oc: IDirigenteExcepcionalConsulta) => (
        <>
          <ExpandAltOutlined style={{ color: "blue" }}
            // shape="round"
            id='detalhar'
            onClick={() => {
              setManter(2);
              getDirigenteExcepcionalPorId(oc.idDirExcepcional);
            }}
          />

          {false && ( //As condições são mais complexas
            <EditOutlined style={{ color: "blue", display: oc.situacaoVigencia ? 'inline' : 'none' }}
              id='alterar'
              onClick={() => {
                setManter(3);
                getDirigenteExcepcionalPorId(oc.idDirExcepcional);
              }} />
          )}
        </>
      ),
    });

    return cols;
  }

  const columns = gerarColunas();

  const handlerCheckConsultaAtivo = (e: CheckboxChangeEvent) => {
    form.setFieldsValue({
      "checkConsultaAtivo": e.target.checked,
    });
  };

  const handlerCheckConsultaInativo = (e: CheckboxChangeEvent) => {
    form.setFieldsValue({
      "checkConsultaInativo": e.target.checked,
    });

  };

  const [entidades, setEntidades] = useState<IEntidade[]>([]);

  const handlerEntidade = async (value: any) => {
    form.setFieldsValue({
      entidade: value.children,
      matriculaEfpc: value.key,
    });
  };

  const dirigenteExcepcionalNaoEncontrado = () => {
    infoMessage("O sistema não encontrou resultado para consulta realizada");
  };

  const obterParametrosDoForm = () => {
    return {
        page: form.getFieldValue("pagina") || 0,
        limit: form.getFieldValue("linhaPorPagina") || DEFAULT_PAGE_SIZE, //linhaPorPagina

        matriculaEfpc: onlyNumbers(form.getFieldValue("matriculaEfpc")) || "",
        nuCpf: onlyNumbers(form.getFieldValue("nuCpf")) || "",
        nmPessoaFisica: form.getFieldValue("nmPessoaFisica") || "",
        idFuncao: form.getFieldValue("idFuncao") || "",
        consultaAtivo: form.getFieldValue("checkConsultaAtivo") || "",
        consultaInativo: form.getFieldValue("checkConsultaInativo") || "",
    };
  }

  const getDirigenteExcepcional = async () => {
    try {
      setLoading(true);

      const params = obterParametrosDoForm();
      let lQuery = `dirigenteExcepcional?${(new URLSearchParams(params)).toString()}`;

      const { data } = await apiCand.get(lQuery);
      setDiritentesExcepcionais(data.content);
      setTotalElements(data.totalElements);
      salvarEstado(params, data.content);

      if (data.content.length === 0) {
        dirigenteExcepcionalNaoEncontrado();
      }
    } catch (error: any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading(false);
    }
  };

  const getDirigenteExcepcionalPorId = async (idDirExcepcional: number) => {
    try {
      setLoading(true);

      let lQuery = `dirigenteExcepcional/${idDirExcepcional}`;
      const { data } = await apiCand.get(lQuery);
      setDirigenteExceptional(data);

    } catch (error: any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading(false);
    }
  };


  const [pageSize, setpageSize] = useState<number>(DEFAULT_PAGE_SIZE);

  const handlePaginationChange = async (page: number, pagination?: number) => {
    if (pagination) {
      setpageSize(pagination);
    }
    form.setFieldsValue({
      pagina: page-1,
    });
    getDirigenteExcepcional();
  };

  const handleShowSizeChange = async (current: any, size: any) => {
    form.setFieldsValue({
      linhaPorPagina: size,
    });
    getDirigenteExcepcional();
  };

  function salvarEstado(parametros :any, dados :any[]) {
    const nmTextos = {
        entidade: form.getFieldValue("entidade") || "",
        nmFuncao: form.getFieldValue("nmFuncao") || "",
    };

    const pesq = {
      resultado: dados,
      parametros: parametros,
      nmTextos: nmTextos
    };
    salvarPesquisa('dirigenteExcepcional', pesq);
  }

  function limparConsulta() {
    setDiritentesExcepcionais([]);
    setDirigenteExceptional(undefined);
    setTotalElements(0);
    limparPesquisaSalva();
    form.resetFields();
  }

  const maskFieldCpf = (isValue: string) => {
    if (form.getFieldValue("nuCpf")) {
      isValue = form.getFieldValue("nuCpf");
    }

    form?.setFieldsValue({
      nuCpf: maskCpf(isValue),
    });
  };

  return (
    <Spin spinning={loading} >

      <>
        <PageHeader
          className="site-page-header"
          title="Consultar Dirigentes Excepcionais"
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />

        <Card variant="borderless" style={{ width: "100%" }}>
          <Form layout="vertical" form={form} style={{ marginTop: "-100px" }}>
            <Form.Item name="pagina" />
            <Form.Item name="linhaPorPagina" />

            <Row>
              <Col xs={12} xl={12}>
                <Form.Item label="Entidade"
                  labelCol={{ span: 12 }}
                  name="entidade"
                  colon={false}
                >
                  <Select
                    showSearch
                    filterOption
                    optionFilterProp='children'
                    placeholder='Selecione a entidade'
                    disabled={entidades.length === 1}
                    onChange={(_, index) => {
                      handlerEntidade(index);
                    }}
                  >
                    {entidades?.map((e: IEntidade) => (
                      <Option key={e.matricula} value={e.matricula}>
                        {e.sigla}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={12} xl={12}>
                <Form.Item label="Função"
                  labelCol={{ span: 12 }}
                  name="nmFuncao"
                  colon={false}
                >
                  <Select
                    showSearch
                    filterOption
                    allowClear
                    optionFilterProp='children'
                    placeholder='Função'
                    onChange={(_, index) => {
                      const value:any = index;
                      if (value){
                        form.setFieldsValue({
                          "nmFuncao": value.children,
                          "idFuncao": value.key,
                        });
                      } else {
                        form.setFieldsValue({
                          "idFuncao": ''
                        });
                      }
                    }}
                  >
                      {funcoes?.map((e: any) => (
                        <Option key={e.csFuncao} value={e.csFuncao}>
                          {e.funcao}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={12} xl={12}>
                <Form.Item
                  label="Situação"
                  colon={false}
                >
                  <Space>
                    <Col>
                      <Form.Item
                        name="checkConsultaAtivo"
                        colon={false}
                        valuePropName="checked"
                      >
                        <Checkbox
                          onChange={handlerCheckConsultaAtivo}
                        >
                          Ativo
                        </Checkbox>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item
                        name="checkConsultaInativo"
                        colon={false}
                        valuePropName="checked"
                      >
                        <Checkbox
                          onChange={handlerCheckConsultaInativo}
                        >
                          Inativo
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Space>
                </Form.Item>
              </Col>
              {/* </Card> */}
            </Row>

            <Row>
              <Col xs={24} sm={5}>
                <Form.Item label="CPF" name="nuCpf">
                  <Input
                    value={form.getFieldValue("nuCpf")}
                    onChange={(e) => maskFieldCpf(e.target.value)}
                    placeholder="Digitar o número do CPF"
                    maxLength={14}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item label="Nome" name="nmPessoaFisica">
                  <Input placeholder="Digitar o nome" />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <>
                <Button
                  style={{ marginRight: "5px" }}
                  id="consultar"
                  type="primary"
                  value="default"
                  shape="round"
                  onClick={() => getDirigenteExcepcional()}
                >
                  Consultar
                </Button>
                <Button
                  id="limpar"
                  value="default"
                  shape="round"
                  onClick={() => limparConsulta()}
                >
                  Limpar
                </Button>
              </>
            </Row>
          </Form>
        </Card>

        <Card title={"Resultado da consulta - " + totalElements + " encontrados"} style={{ display: totalElements === 0 ? 'none' : 'inline' }}>
          <Table
            // className="overflowConsulta"
            dataSource={diritentesExcepcionais}
            size={"small"}
            columns={columns}
            rowKey="idDiriExcepcional"
            loading={loading}
            pagination={{
              // disabled: loading,
              // current: form.getFieldValue("pagina"),
              defaultPageSize: DEFAULT_PAGE_SIZE,
              pageSize: pageSize,
              total: totalElements,
              showSizeChanger: true,
              onShowSizeChange: handleShowSizeChange,
              onChange: handlePaginationChange,
              pageSizeOptions: PAGE_SIZE_OPTIONS,
              locale: { items_per_page: "Linhas por página" },
            }}
          />
        </Card>
      </>
    </Spin>
  );
};

export default Consultar;
